module.exports = __webpack_public_path__ + "img/base.0ad2c182.png";